function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var NumberFieldTemplate = require('./number.template');
var _require = require('../../script_build'),
  isPlaceholder = _require.isPlaceholder;
var NumberFieldOverlay = /*#__PURE__*/function () {
  function NumberFieldOverlay(app, mod) {
    _classCallCheck(this, NumberFieldOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.currentValue = '';
    this.title = 'Number';
    this.placeholder = '0';
    this.onApply = null;
  }
  return _createClass(NumberFieldOverlay, [{
    key: "render",
    value: function render() {
      var _this$currentValue;
      var raw = isPlaceholder(this.currentValue) ? '' : String((_this$currentValue = this.currentValue) !== null && _this$currentValue !== void 0 ? _this$currentValue : '');
      this.overlay.show(NumberFieldTemplate({
        title: this.title,
        value: raw,
        placeholder: this.placeholder
      }));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _root$querySelector,
        _this = this;
      var host = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      var root = host === null || host === void 0 ? void 0 : host.querySelector('.rs-prompt-number-panel');
      var input = root === null || root === void 0 ? void 0 : root.querySelector('.rs-prompt-number-input');
      if (!root || !input) {
        return;
      }
      input.focus({
        preventScroll: true
      });
      var validation = root.querySelector('.rs-prompt-validation');
      var showError = function showError(message) {
        if (!validation) {
          return;
        }
        validation.hidden = false;
        validation.textContent = message;
      };
      var clearError = function clearError() {
        if (validation) {
          validation.hidden = true;
          validation.textContent = '';
        }
      };
      input.addEventListener('input', clearError);
      (_root$querySelector = root.querySelector('.rs-prompt-apply')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        var _input$value;
        var next = String((_input$value = input.value) !== null && _input$value !== void 0 ? _input$value : '').trim();
        if (!next || isPlaceholder(next)) {
          showError('A value is required');
          return;
        }
        if (!/^-?\d+$/.test(next)) {
          showError('Expected an integer');
          return;
        }
        clearError();
        if (typeof _this.onApply === 'function') {
          _this.onApply(Number(next));
        }
        _this.overlay.hide();
      });
    }
  }]);
}();
module.exports = NumberFieldOverlay;